<template>
  <div class="docuform-preview">

    <div class="docuform-preview__empty-state-container" v-if="isInfected">
      <EmptyState svgPath="preview_empty_state.svg"
                  :title="$t('file.missing_file_error.title')"
                  :subtitle="subtitleText">
        <template #footer>
          <div class="empty-state__buttons-wrap">
            <VcButton v-if="canReUpload" :label="$t('file.missing_file_error.replace_cta')" pill  @click="openInfectedDialog" class="empty-state__reupload" />
            <VcButton v-if="canSendRequest" :label="$t('file.missing_file_error.send_request_cta')" pill @click="sendRequest" class="empty-state__send-request" color="secondary" outlined/>
            <VcButton v-if="$hasFeature('documents_corrupted')" :label="$t('file.missing_file_error.learn_more')" plain @click="navigateToSupport" class="empty-state__live-text" />
          </div>
        </template>
      </EmptyState>
    </div>
    <iframe v-else id="docuform-iframe" class="docuform-preview__iframe" title="Document Inline Frame" :src="preview_src" />
  </div>
</template>

<script>
import EmptyState from '@/modules/common/components/EmptyState/EmptyState';
export default {
  name: "DocuformPreview",
  components: { EmptyState },
  props: {
    preview_src: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    accountCanSendLink: {
      type: Boolean,
      default: false,
    }
  },
  created() {
    window.addEventListener('message', this.documentsAppMessage);
  },
  computed: {
    isInfected() {
      return this.item.metadata?.infected === "true"
    },
    canReUpload() {
      return this.$hasFeature('documents_reupload')
    },
    canSendRequest(){
      return this.$hasFeature('documents_reupload_portal') && this.accountCanSendLink && this.isClientInitiated;
    },
    isClientInitiated() {
      return this.item.initiator === 'Client';
    },
    fileName() {
      return this.item.fileName || this.item.metadata?.file_name
    },
    subtitleText() {
      const params = {filename: this.fileName};

      if (this.canReUpload) {
        return this.canSendRequest ? this.$t('file.missing_file_error.subtitle_with_request', params) : this.$t('file.missing_file_error.subtitle', params);
      } else {
        return this.$t('file.missing_file_error.subtitle_upload_denied', params);
      }
    }
  },
  methods: {
    navigateToSupport() {
      this.$frontageApi.openExternal('https://support.vcita.com/hc/en-us/articles/4429280386071-Important-update-regarding-documents-stored-in-vcita');
    },
    openInfectedDialog() {
      this.$frontageApi.send('infected-file', this.item);
    },
    sendRequest(){
      this.$frontageApi.send('send-file-request-action', this.item)
    },
    documentsAppMessage(event) {
      const {label, data} = event.data;

      switch (label) {
        case 'documents-app-error-log':
          this.$logError('DOCUMENTS APP ERROR', data);
          break;
        case 'document-preview-tracking':
          this.$track('Document activity page action', {file_type: data, origin: 'backoffice'});
          break;
      }
    }
  },
  destroyed() {
    window.removeEventListener('message', this.documentsAppMessage);
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.docuform-preview {
  min-height: calc(100% - 48px);
  position: relative;
  overflow: hidden;

  &__iframe {
    position: absolute;
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    left: 0;
    top: 0;
    border: none;
    overflow-x: hidden;
    overflow-y: auto;
  }

  &__empty-state-container {
    display: flex;
    position: absolute;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }


  .empty-state {

    &__buttons-wrap {
      padding-bottom: 10px;
      width: 212px;
      text-align: center;
      align-items: center;
      display: flex;
      flex-direction: column;
    }

    &__reupload, &__send-request {
      margin-bottom: 16px;
      font-weight: 700;
      width: 100%;
      border: 1px solid $brand_secondary_color;
    }

    &__send-request, &__live-text {
      margin-top: 0;
    }

    &__send-request {
      background-color: #fff!important;
      color: $brand_secondary_color!important;
    }

    &__live-text {
      color: $blue-color-4!important;
    }
  }
}
</style>
